import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'prelogin-footer',
    templateUrl: './pre-login-footer.component.html',
    styleUrls: ['./pre-login_footer.scss', '../pre-login.component.scss']
})
export class PreLoginFooterComponent {
    currentYear = new Date().getFullYear();
    constructor(private router: Router) { }

    home() {
        this.router.navigate(['/pre-login']);
    }

    faqPage() {
        this.router.navigate(['faq']);
    }

    clickhome() {
        var el = document.getElementById('nav-home');
        el.click();
    }

    clickOutlet() {
        
        var el = document.getElementById('nav-outlet');
        el.click();
    }

    clickFAQS() {
        debugger
        var el = document.getElementById('nav-FAQS');
        el.click();
    }

    // ✅ Updated — Works even when header link is removed
    termsAndConditionsPage() {
        debugger
         var el = document.getElementById('termsandconditions');
        el.click();
        // this.router.navigate(['termsandconditions']);
    }
    clickprivacy() {
        debugger
          var el = document.getElementById('privacypolicy');
        el.click();
        // this.router.navigate(['privacypolicy']);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/pre-login-footer/pre-login-footer.component.ts